<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productAssembly.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productAssembly.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-end ts-items-center">
          <ts-input
            v-tooltip="$t('productAssembly.search')"
            v-model="search"
            :placeholder="$t('search')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <Table
          :data="resources" 
          :columns="columns" 
          size="small"
          highlight-row
          stripe
          max-height="700"
          :loading="loading"
        >
          <template slot-scope="{ row }" slot="barcode">
            {{ row.product.barcode }}        
          </template>
          <template slot-scope="{ row }" slot="groupNameEn">
            {{ row.product.pro_group_name_en }}
          </template>
          <template slot-scope="{ row }" slot="productNameKh">
            {{ row.product.product_name_kh }}
          </template>
          <template slot-scope="{ row }" slot="productNameEn">
            {{ row.product.product_name_en }}
          </template>
          <template slot-scope="{ row }" slot="categoryNameEn">
            {{ row.product.category_name_en }}
          </template>
          <template slot-scope="{ row }" slot="uomNameEn">
            {{ row.unit_of_measure.uom_name_en }}
          </template>
          <template slot-scope="{ row }" slot="assembliesCount">
            <span class="badge badge-success" v-if="row.assemblies_count">Yes</span>
            <span class="badge badge-danger" v-else>No</span>
          </template>
          <template slot-scope="{ row }" slot="action">
							<a href="#" 
								v-tooltip="$t('add_new')"
								@click.prevent="chosen(row)"
							>
								<i class="fa fa-plus"></i>
							</a>
          </template>
        </Table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
		<a-modal v-model="showForm" 
			:title="$t('productAssembly.pageTitle')" 
			:footer="null"
			:maskClosable="false"
			:zIndex="1020"
			width="50%"
		>
			<FormComponent 
        :saleCodeId="saleCodeId"
        @cancel="onCancel"
      />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './components/form'

export default {
	name: 'profileIndex',
	components: {
		FormComponent
	},
  data() {
    return {
      loading: false,
      showForm: false,
      saleCodeId: null
    }
  },
  computed: {
    ...mapState('product/assembly', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.assembly.search
      },
      set(newValue) {
        this.$store.commit('product/assembly/SET_SEARCH', newValue)
        this.$store.commit('product/assembly/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { 
          title: this.$t('productAssembly.barcode'),
          slot: 'barcode',
          style: 'width: 11%' 
        },
        { 
          title: this.$t('productAssembly.group'),
          slot: 'groupNameEn'
        },
        { 
          title: this.$t('productAssembly.nameKh'),
          slot: 'productNameKh'
        },
        { 
          title: this.$t('productAssembly.nameEn'),
          slot: 'productNameEn'
        },
        { 
          title: this.$t('productAssembly.category'),
          slot: 'categoryNameEn'
        },
        { 
          title: this.$t('productAssembly.uom'),
          align: 'center',
          slot: 'uomNameEn'
        },
        { 
          title: this.$t('productAssembly.recipes'),
          align: 'center',
          slot: 'assembliesCount'
        },
        {
					title: this.$t('actions'),
					key: 'action',
					slot: 'action',
					fixed: 'right',
					align: 'center',
					width: 94
				}
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/assembly/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
		},
		chosen(record){
      this.showForm = true
      this.saleCodeId = record.pro_sale_code_id
    },
    onCancel(){
      this.showForm = false
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/assembly/RESET_STATE')
    this.$store.commit('product/assembly/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>